import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  Input,
} from "@angular/core";
import { GroupDto, IdentityUserDto, LandTitleDto, SubGroupDto, SubSubGroupDto } from "@cradua/data";
import { fromEvent, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  pluck,
  tap,
} from "rxjs/operators";
import { AcquisitionRole } from "../../../aquisition-role.enum";

@Component({
  selector: "cradua-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
})
export class SearchComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() activities: any[];
  @Input() subSubGroups: SubSubGroupDto[];
  @Input() subGroups: SubGroupDto[];
  @Input() groups: GroupDto[];
  @Input() landTitle: LandTitleDto[];
  @Input() task: string;
  @Input() view: string;
  @Input() showCreateBtn = true;
  @Output() searchEmit = new EventEmitter<any>();
  @Output() emitEvent = new EventEmitter<any>();
  @Output() emitTask = new EventEmitter<any>();

  @ViewChild("search", { static: true })
  searchForm: ElementRef;
  searchSubscription$: Subscription;
  filterSubGroup: SubGroupDto[];
  filterSubSubGroup: SubSubGroupDto[];
  selectedGroupId = "";
  selectedSubGroupId = "";
  selectedSubSubGroupId = "";
  isFilter = false;
  selectedActivity: any;

  constructor() {}

  ngOnInit(): void {
    this.selectedActivity = this.activities.find(item => item?.activityName === AcquisitionRole.VIEWACQUISITION &&
      item?.activitySelectedValue === AcquisitionRole.READWRITE);
  }

  ngAfterViewInit(): void {
    this.searchSubscription$ = fromEvent(this.searchForm.nativeElement, "keyup")
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        pluck("target", "value"),
        tap(_ => this.task === 'list' ? null : this.emitTask.emit('list')),
        // filter((searchTerm: string) => searchTerm.length > 2),
        map((value) => value),
      )
      .subscribe((data) => this.searchEmit.emit(data));
  }

  filterWithGroupId() {
    this.searchEmit.emit(this.selectedGroupId);
  }

  protected filterById = <T>(id: string, lookupId: string) =>
    (fieldName: T) => fieldName[lookupId] === id;

  onFilterSubGroup(id: string) {
    this.selectedGroupId = id;
    this.filterSubGroup = this.subGroups.filter(
      this.filterById<SubGroupDto>(id, "GroupId"),
    );
  }

  filterWithSubGroupId() {
    this.searchEmit.emit(this.selectedSubGroupId);
  }

  onFilterSubSubGroup(id: string) {
    this.selectedSubGroupId = id;
    this.filterSubSubGroup = this.subSubGroups.filter(
      this.filterById<SubSubGroupDto>(id, "SubGroupId"),
    );
  }

  onSelectSubSubGroupId(id: string) {
    this.selectedSubSubGroupId = id;
  }

  filterWithSubSubGroupId() {
    this.searchEmit.emit(this.selectedSubSubGroupId);
  }

  createEvent() {
    this.emitTask.emit('create')
  }

  onFilter() {
    this.isFilter = !this.isFilter;
    this.emitTask.emit('list')
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.searchSubscription$) {
      this.searchSubscription$.unsubscribe();
    }
  }
}
